
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Role = {
  ADMIN: 'ADMIN',
  USER: 'USER'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const LearningStyle = {
  RIGID_SEQUENTIAL: 'RIGID_SEQUENTIAL',
  FLEXIBLE_SEQUENTIAL: 'FLEXIBLE_SEQUENTIAL',
  UNSTRUCTURED: 'UNSTRUCTURED'
} as const

export type LearningStyle = (typeof LearningStyle)[keyof typeof LearningStyle]


export const BrandingType = {
  DR_PAM: 'DR_PAM',
  NDC: 'NDC',
  PSP: 'PSP',
  BSB: 'BSB',
  SBY: 'SBY'
} as const

export type BrandingType = (typeof BrandingType)[keyof typeof BrandingType]


export const NdcAwardKind = {
  ACCREDITATION: 'ACCREDITATION',
  FELLOWSHIP: 'FELLOWSHIP',
  PROVIDERS_EDUCATORS: 'PROVIDERS_EDUCATORS'
} as const

export type NdcAwardKind = (typeof NdcAwardKind)[keyof typeof NdcAwardKind]


export const NdcLegacyLicenceDecision = {
  INDEPENDENT: 'INDEPENDENT',
  PAID: 'PAID'
} as const

export type NdcLegacyLicenceDecision = (typeof NdcLegacyLicenceDecision)[keyof typeof NdcLegacyLicenceDecision]


export const AcceptedCurrency = {
  AUD: 'AUD',
  USD: 'USD',
  GBP: 'GBP',
  EUR: 'EUR',
  CAD: 'CAD',
  NZD: 'NZD'
} as const

export type AcceptedCurrency = (typeof AcceptedCurrency)[keyof typeof AcceptedCurrency]


export const UpgradeType = {
  PRORATING: 'PRORATING',
  ADD_DAYS: 'ADD_DAYS'
} as const

export type UpgradeType = (typeof UpgradeType)[keyof typeof UpgradeType]


export const UpgradeDurationMode = {
  REFRESH: 'REFRESH',
  CONVERT: 'CONVERT'
} as const

export type UpgradeDurationMode = (typeof UpgradeDurationMode)[keyof typeof UpgradeDurationMode]


export const UpgradePromptType = {
  BANNER: 'BANNER',
  MODAL: 'MODAL',
  TOAST: 'TOAST'
} as const

export type UpgradePromptType = (typeof UpgradePromptType)[keyof typeof UpgradePromptType]


export const PromptFrequency = {
  ONCE: 'ONCE',
  ONCE_PER_DAY: 'ONCE_PER_DAY',
  ONCE_PER_SESSION: 'ONCE_PER_SESSION',
  EVERY_PAGE_LOAD: 'EVERY_PAGE_LOAD',
  EVERGREEN: 'EVERGREEN'
} as const

export type PromptFrequency = (typeof PromptFrequency)[keyof typeof PromptFrequency]


export const PaymentDiscountSource = {
  NONE: 'NONE',
  COUPON: 'COUPON',
  UPGRADE_PROMPT: 'UPGRADE_PROMPT'
} as const

export type PaymentDiscountSource = (typeof PaymentDiscountSource)[keyof typeof PaymentDiscountSource]


export const CouponDiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT'
} as const

export type CouponDiscountType = (typeof CouponDiscountType)[keyof typeof CouponDiscountType]


export const StripePaymentIntentStatus = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
} as const

export type StripePaymentIntentStatus = (typeof StripePaymentIntentStatus)[keyof typeof StripePaymentIntentStatus]


export const UserArticleAction = {
  OPENED: 'OPENED',
  READ: 'READ'
} as const

export type UserArticleAction = (typeof UserArticleAction)[keyof typeof UserArticleAction]


export const TemplateType = {
  USER_REQUEST_RESET: 'USER_REQUEST_RESET',
  INVOICE_PDF: 'INVOICE_PDF',
  INVOICE_EMAIL: 'INVOICE_EMAIL',
  SUBSCRIPTION_EXPIRING_SOON_EMAIL: 'SUBSCRIPTION_EXPIRING_SOON_EMAIL',
  SUBSCRIPTION_EXPIRING_TOMORROW_EMAIL: 'SUBSCRIPTION_EXPIRING_TOMORROW_EMAIL',
  SUBSCRIPTION_EXPIRED_EMAIL: 'SUBSCRIPTION_EXPIRED_EMAIL',
  SUBSCRIPTION_RENEWING_SOON_EMAIL: 'SUBSCRIPTION_RENEWING_SOON_EMAIL',
  SUBSCRIPTION_RENEWING_TOMORROW_EMAIL: 'SUBSCRIPTION_RENEWING_TOMORROW_EMAIL',
  SUBSCRIPTION_RENEWED_EMAIL: 'SUBSCRIPTION_RENEWED_EMAIL',
  SUBSCRIPTION_RENEWAL_FAILED_EMAIL: 'SUBSCRIPTION_RENEWAL_FAILED_EMAIL',
  SUBSCRIPTION_CANCELLED_EMAIL: 'SUBSCRIPTION_CANCELLED_EMAIL',
  EVENT_REGISTRATION_CONFIRMATION_EMAIL: 'EVENT_REGISTRATION_CONFIRMATION_EMAIL',
  EVENT_REGISTRATION_CANCELLED_EMAIL: 'EVENT_REGISTRATION_CANCELLED_EMAIL',
  CONTACT_FORM: 'CONTACT_FORM',
  WELCOME_EMAIL: 'WELCOME_EMAIL',
  NDC_ACCREDITATION_CERTIFICATE_PDF: 'NDC_ACCREDITATION_CERTIFICATE_PDF',
  NDC_FELLOWSHIP_CERTIFICATE_PDF: 'NDC_FELLOWSHIP_CERTIFICATE_PDF',
  NDC_PROVIDERS_EDUCATORS_CERTIFICATE_PDF: 'NDC_PROVIDERS_EDUCATORS_CERTIFICATE_PDF',
  NDC_ACCREDITATION_LICENCE_PDF: 'NDC_ACCREDITATION_LICENCE_PDF',
  NDC_PROVIDERS_EDUCATORS_LICENCE_PDF: 'NDC_PROVIDERS_EDUCATORS_LICENCE_PDF'
} as const

export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType]
